<template>
  <button
    :class="$style.buttonWrapper"
    :data-test-id="$testId('button')"
    @click="handleToggle"
  >
    <Card
      :class="[
        $style.container,
        {[$style.selectBorder]: isSelected}
      ]"
    >
      <div :class="$style.header">
        <span :class="$style.label">
          <Icon
            v-if="useCase.icon"
            :class="$style.icon"
            :icon="useCase.icon"
            :scale="2"
          />

          <HeadingExtraSmall>
            {{ useCase.label }}
          </HeadingExtraSmall>
        </span>

        <Icon
          v-if="isSelected"
          :class="$style.successIcon"
          icon="checkmarkCircle"
          :scale="1.5"
        />
      </div>

      <ParagraphBody v-if="useCase.description">
        {{ useCase.description }}
      </ParagraphBody>
    </Card>
  </button>
</template>

<script>
import {
  Card,
  HeadingExtraSmall,
  Icon,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'UseCaseCard',

  components: {
    Card,
    HeadingExtraSmall,
    Icon,
    ParagraphBody,
  },

  props: {
    selected: {
      type: String,
      required: true,
    },

    useCase: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isSelected() {
      if (this.selected === this.useCase.label) {
        return true;
      }

      return false;
    },
  },

  methods: {
    handleToggle() {
      this.$emit('click', this.useCase);
    },
  },
};
</script>

<style module scoped>
.buttonWrapper.buttonWrapper {
  border-radius: var(--jc-border-radius);
  color: inherit;
  font-weight: inherit;
  height: 100%;
  padding: 0;
  text-align: inherit;
  transition: box-shadow var(--jc-transition-duration-fast) var(--jc-transition-function);
  width: 100%;
}

.buttonWrapper:hover {
  box-shadow: var(--jc-box-shadow-clickable-hover);
  cursor: pointer;
}

.buttonWrapper:focus.buttonWrapper:focus {
  box-shadow: var(--jc-focus-outline);
}

.container {
  height: 100%;
  width: 100%;
}

.selectBorder {
  border-color: var(--jcPrimary);
  box-shadow: inset 0 0 0 1px var(--jcPrimary);
}

.header,
.label {
  align-items: center;
  display: flex;
}

.header {
  justify-content: space-between;
  margin-bottom: var(--jc-spacer);
}

.icon {
  margin-inline-end: var(--jc-spacer-small);
}

.successIcon {
  color: var(--jcPrimary);
}
</style>
